import { Asset } from "./asset";
import { PaginationInfo } from "./commons/paginated-response";
import { SearchFilter } from "./commons/search-filter";
import { Brand } from "./brand";
import { t } from "@lingui/macro";

export enum ContractStatus {
    ACTIVE = "ACTIVE", //
    NEGOTIATING = "NEGOTIATING", //
    CREATED = "CREATED",
    CLOSED = "CLOSED", //
    REJECTED = "REJECTED", //
}

export enum ContractType {
    BUY = "BUY", //
    LEASE = "LEASE", //
    TEMPORARY_LEASE = "TEMPORARY_LEASE", //
    BRANCH_LEASE = "BRANCH_LEASE", //
}
class ContractTypeTranslations {
    BUY = t({ id: "enums.contract-type.BUY", message: "Acquisto" })
    LEASE = t({ id: "enums.contract-type.LEASE", message: "Affitto" })
    TEMPORARY_LEASE = t({ id: "enums.contract-type.TEMPORARY_LEASE", message: "Locazione temporanea" })
    BRANCH_LEASE = t({ id: "enums.contract-type.BRANCH_LEASE", message: "Affitto di ramo d'azienda" })
}

interface ContractItem {
    id: string
    contractNumber: string | null
    status: string | null
    signDate: Date | null
    startDate: Date | null
    endDate: Date | null
}

export interface ContractListItem extends ContractItem {
    brandName: string | null
    assetAddress: string | null
}

export interface ContractDetailItem extends ContractItem {
    brand: Brand | null
    asset: Asset | null
}

export interface BrandContracts extends ContractItem {
    asset: Asset | null
}

export interface CreateContract {
    contractNumber: string
    status: ContractStatus
    brandId: string
    assetId: string
    startDate: string
    endDate: string
    signDate: string
}

export interface CreateContractWithId extends CreateContract {
    id: string
}

export interface ContractResponse {
    items: ContractListItem[]
    pagination: PaginationInfo
}

export class ContractRequest extends SearchFilter {
    contractNumber: string | null = null
    statusList: string[] | null = null
    brandId: string | null = null
    assetId: string | null = null
    minStartDate: Date | null = null
    maxStartDate: Date | null = null
}
